@if (state.ongoingActivity && state.canShowResumeButton) {
  <small-layout>
    <div class="aligner relative h-8 bg-teal-500 px-4" (click)="resumeActivity()" @appearDisappearWithHeight>
      <span class="text-neutral-0 text-sm font-semibold">{{
        'resume_course_activity'
          | transloco
            : {
                course: state.courseShortLabel ?? '',
                activity: (state.ongoingActivity.nameKey | transloco | lowercase)
              }
      }}</span>
      <dojo-icon [icon]="'arrow-right'" class="text-neutral-0 absolute right-4"></dojo-icon>
    </div>
  </small-layout>
  <wide-layout @appearDisappear>
    <button
      class="resume-activity-button"
      (click)="resumeActivity()"
      [matTooltip]="
        'resume_course_activity'
          | transloco
            : {
                course: state.courseShortLabel ?? '',
                activity: (state.ongoingActivity.nameKey | transloco | lowercase)
              }
      "
      [matTooltipPosition]="'right'"
    >
      <div class="sidebar-link-text flex flex-col items-start">
        <span class="mb-0.5 h-4 whitespace-nowrap text-xs font-semibold uppercase text-teal-100">
          {{ state.courseShortLabel }}
        </span>
        <span class="text-neutral-0 whitespace-nowrap text-left text-sm font-semibold">{{
          'resume_activity' | transloco: { activity: (state.ongoingActivity.nameKey | transloco | lowercase) }
        }}</span>
      </div>
      <dojo-icon icon="circle-play" size="28" faPrefix="fas" class="text-teal-100" />
    </button>
  </wide-layout>
}
